// extracted by mini-css-extract-plugin
export var ImageCredit = "ImageCredit-module--ImageCredit--7XCnx";
export var aniSpin = "ImageCredit-module--ani-spin---Nm0n";